import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { Link, Redirect, withRouter } from 'react-router-dom';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import InfoArea from 'components/InfoArea/InfoArea.jsx';
import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import HOCLoader from '../HOC/HOCLoader';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import ProgressiveImage from 'react-progressive-image';

import top1 from 'assets/images/services/20.jpg';
import top2 from 'assets/images/services/p1.jpg';
import top3 from 'assets/images/services/10.jpg';
import top4 from 'assets/images/services/ser5.jpg';
let isMounted = false;
class TopCategories extends React.Component {
    constructor() {
        super();
        this.state = { redirect: false, itemId: null };
    }
    componentDidMount() {
        isMounted = true;

        this.getData();
    }
    getData = () => {
        if (isMounted) {
            this.props.allCategoryAction();
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }
    redirectCategory = categoryId => {
        this.setState({ redirect: true, itemId: categoryId });
    };

    renderLoading = index => {
        return (
            <div style={{ width: 200, margin: 10, height: 160 }} key={index}>
                <ContentLoader
                    height={160}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };
    render() {
        const { classes } = this.props;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/category/services/`,
                state: { itemId: this.state.itemId }
            });
        }

        return (
            <div>
                <div>
                    <div className="land-full land-packages">
                        <div className="container">
                            <div className="com-title">
                                <h2>Popular Categories</h2>
                                <p>
                                    Our Popular Categories you can choose sitting
                                    at your home
                                </p>
                            </div>
                            <div className="land-pack">
                                <ul>
                                    {this.props.categoryData
                                        .slice(0, 4)
                                        .map((category, index) => {
                                            if (category.key) {
                                                return (
                                                    <li key={index}>
                                                        <div className="land-pack-grid">
                                                            <div className="land-pack-grid-img">
                                                                <img
                                                                    width="300px"
                                                                    height="160px"
                                                                    src={
                                                                        category
                                                                            .image
                                                                            .medium
                                                                    }
                                                                    alt={
                                                                        category.heading
                                                                    }
                                                                    className="category-image"
                                                                />
                                                            </div>
                                                            <div className="land-pack-grid-text">
                                                                <h4>
                                                                    {
                                                                        category.heading
                                                                    }
                                                                </h4>
                                                                <a
                                                                    className="land-pack-grid-btn"
                                                                    onClick={() =>
                                                                        this.redirectCategory(
                                                                            category.id
                                                                        )
                                                                    }
                                                                >
                                                                    Book Now
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            } else {
                                                return this.renderLoading(
                                                    index
                                                );
                                            }
                                        }
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const composedComponent = compose(
    withStyles(productStyle),
    connect(null, actions)
);
export default composedComponent(withRouter(TopCategories));



// WEBPACK FOOTER //
// ./src/components/Category/TopCategories.js